<template>
  <b-row v-if="schedules"  style="padding-bottom:40px;">
    <b-col cols="12" style="border-bottom:1px solid #F7F7F8;">
      <div class="days_row">
        <div class="day_box" :class="{active_day_box:isDayActive(date)}" @click="changeHoursRange(date)" v-for="(date, idxd) in schedules" v-bind:key="idxd">
          {{date.day}}<br/>
          <span style="font-size:16px">{{date.month.toUpperCase()}}</span>
        </div>
        <div class="day_box" style="background-color:#ffffff;"><!-- spacer --></div>
      </div>
    </b-col>
    <b-col cols="12" v-if="selectedDate" style="border-bottom:1px solid #F7F7F8;padding-top:10px;font-size: 14px; color: #525962;">
      <span style="font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        color: #121C2A;">Dia {{selectedDate.day}}</span>
        <p style="text-transform: capitalize;">
        {{selectedDate.dayOfWeek}}
        </p>
    </b-col>
    <b-col cols="12" v-if="selectedDate" >
      <b-row v-for="(range, idxr) in selectedDate.range" v-bind:key="idxr" style="border-bottom:1px solid #F7F7F8;height:36px;margin-top:18px;">
        <b-col cols="2" style="text-align:right;">
          <input type="radio" name="range_choice" style="width:20px;height:20px;" :style="{opacity:(!range.active ? 0.5 : 1)}" :disabled="!range.active" :checked="range.selected" @change="selectRange(selectedDate, range)"/>
        </b-col>
        <b-col style="font-size: 14px;line-height: 17px;color: #525962;" :style="{opacity:(!range.active ? 0.5 : 1)}">{{range.from}}h - {{range.to}}h</b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col style="
    margin-top:23px;
    font-style: normal;
    font-weight: normal;
    line-height: 17px;
    font-size: 14px;
    text-align: center;
    color: #525962;
    ">
      Sem data de agendamento dispoível.
    </b-col>
  </b-row>
</template>

<script>
import formaters from '@/mixins/formaters'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {

  data () {
    return {
      schedules: [],
      todayInSchedule: null,
      selectedDate: null,
    }
  },

  mixins: [formaters],

  computed: {
    ...mapGetters([ 'getChoicedCompany' ])
  },

  created () {
    console.log(this.getChoicedCompany.agenda)
    let today = new Date()
    let max = this.getChoicedCompany.schedule_max_days || 2
    for (let x=0; x < max; x++) {
      let isToday = true
      if (x > 0){
        today.setDate(today.getDate() + 1)
        isToday = false
      }
      let dtObject = _.clone(today)
      this.schedules.push(this.getDayInSchedule(today.getDay(), today.getDate(), today.getMonth(), isToday, dtObject))
    }
    if (this.schedules.length) {
      this.selectedDate = this.schedules[0]
      this.selectFirst()
    }
    console.log(this.schedules)
  },

  methods: {

    selectFirst () {
      let first = null
      let range = null
      for (let x=0; x<this.schedules.length; x++){
        for (let y=0; y<this.schedules[x].range.length; y++){
          if (this.schedules[x].range[y].active && (this.schedules[x].day > new Date().getDate() || this.schedules[x].range[y].to > new Date().getHours() )){
            this.selectedDate = this.schedules[x]
            first = this.schedules[x].range[y]
            range = this.selectRange(this.selectedDate, first)
            // timestamp
            let timeSchedule = this.selectedDate.dtObject
            timeSchedule.setHours(first.from)
            timeSchedule.setMinutes(0)
            timeSchedule.setSeconds(0)
            this.$emit('firstSchedule', range, timeSchedule.getTime())
            return range
          }
        }
      }
    },

    selectRange (date, range) {
      for (let x=0; x<this.schedules.length; x++){
        for (let y=0; y<this.schedules[x].range.length; y++){
          this.schedules[x].range[y].selected = false
        }
      }
      range.selected = true
      let scheduleInfo = date.day + '/' + date.month  + '  ' + range.from + 'h - ' + range.to + 'h'
      let timeSchedule = date.dtObject
      timeSchedule.setHours(range.from)
      timeSchedule.setMinutes(0)
      timeSchedule.setSeconds(0)
      this.$emit('selectedSchedule', scheduleInfo, timeSchedule.getTime())
      return scheduleInfo
    },

    changeHoursRange (date) {
      this.selectedDate = date
    },

    isDayActive (date) {
      return this.selectedDate && date.day === this.selectedDate.day && date.month === this.selectedDate.month
    },

    getDayInSchedule (dayIndex, day, month, today, dtObject) {
      let shecheduleDay = {
        range: [],
        day: day,
        dayOfWeek: this.getDayOfWeek(dayIndex),
        month: this.getMonthShort(month),
        dtObject: dtObject
      }
      switch (dayIndex) {
        case 0 :
          shecheduleDay.range = this.getChoicedCompany.agenda.sunday
          break
        case 1 :
          shecheduleDay.range = this.getChoicedCompany.agenda.monday
          break
        case 2 :
          shecheduleDay.range = this.getChoicedCompany.agenda.tuesday
          break
        case 3 :
          shecheduleDay.range = this.getChoicedCompany.agenda.wednesday
          break
        case 4 :
          shecheduleDay.range = this.getChoicedCompany.agenda.thursday
          break
        case 5 :
          shecheduleDay.range = this.getChoicedCompany.agenda.friday
          break
        case 6 :
          shecheduleDay.range = this.getChoicedCompany.agenda.saturday
          break
      }
      // if is today, remove the time ranges in past
      if (today) {
        shecheduleDay.range = this.removePastTimeHours(shecheduleDay.range)
      }
      return shecheduleDay
    },

    removePastTimeHours (r) {
      let now = new Date().getHours()
      for (let x=0; x<r.length; x++){
        if (now >= r[x].to){
          r[x].active = false
        }
      }
      return r
    },

    getDayOfWeek (d) {
      let day = 'domingo'
      switch (d) {
        case 1:
          day = 'segunda-feira'
          break
        case 2:
          day = 'terça-feira'
          break
        case 3:
          day = 'quarta-feira'
          break
        case 4:
          day = 'quinta-feira'
          break
        case 5:
          day = 'sexta-feira'
          break
        case 6:
          day = 'sábado'
          break
      }
      return day
    },

    getMonthShort (m) {
      let month = 'jan'
      switch (m) {
        case 1:
          month = 'fev'
          break
        case 2:
          month = 'mar'
          break
        case 3:
          month = 'abr'
          break
        case 4:
          month = 'mai'
          break
        case 5:
          month = 'jun'
          break
        case 6:
          month = 'jul'
          break
        case 7:
          month = 'ago'
          break
        case 8:
          month = 'set'
          break
        case 9:
          month = 'out'
          break
        case 10:
          month = 'nov'
          break
        case 11:
          month = 'dez'
          break
      }
      return month
    }
  }

}
</script>

<style lang="scss">

.days_row {
  height: 70px;
  width: 100vw;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  display: inline-flex; margin-top:10px;line-height:24px;
}

.day_box {
  cursor:pointer;
  text-align:center;
  height:56px;
  float:left;
  background: #FFFFFF;
  padding: 5px 15px;;
  margin:5px;
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  border: 0px;
  border-radius:4px;
  color: #979797;
}

.active_day_box {
  background: #F7F7F8;
  color: #5E2B8B;
}


</style>
